import { useEffect, useState } from 'react';
import Plot from 'react-plotly.js';
import { api } from '../api/client';
import type { InteractionEffect, LagProfile } from '../types';

export function InteractionsLagsPage() {
  const [interactions, setInteractions] = useState<InteractionEffect[]>([]);
  const [lags, setLags] = useState<LagProfile[]>([]);

  useEffect(() => {
    Promise.all([api.interactions(), api.lags()]).then(([i, l]) => {
      setInteractions(i);
      setLags(l);
    }).catch(console.error);
  }, []);

  return (
    <div>
      <h1 className="page-title">Interactions & Lags</h1>
      <p className="page-subtitle">Cross-policy complementarities/conflicts and indicative realization profiles.</p>

      <div className="card">
        <h3>Policy Interactions</h3>
        <table className="data-table">
          <thead>
            <tr><th>Interaction</th><th>Type</th><th>Max effect</th><th>Selected contribution</th></tr>
          </thead>
          <tbody>
            {interactions.map((i) => (
              <tr key={i.name}>
                <td>{i.name}</td>
                <td>{i.interaction_type}</td>
                <td>{i.max_effect_pp?.toFixed(3)} pp</td>
                <td>{i.contribution_pp?.toFixed(3)} pp</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="card">
        <h3>Policy Lag Profiles (reference)</h3>
        <Plot
          data={lags.map((l) => ({
            type: 'scatter',
            mode: 'lines+markers',
            name: l.family.slice(0, 30),
            x: ['Y1', 'Y2', 'Y3', 'Y4', 'Y5'],
            y: [l.y1, l.y2, l.y3, l.y4, l.y5],
          }))}
          layout={{
            title: 'Realization Profiles by Policy Family',
            paper_bgcolor: '#fff',
            plot_bgcolor: '#fff',
            yaxis: { title: 'Cumulative realization', tickformat: '.0%', range: [0, 1.05] },
            margin: { t: 50, r: 20, b: 40, l: 50 },
          }}
          config={{ displayModeBar: false, responsive: true }}
          style={{ width: '100%', height: 400 }}
        />
        <p style={{ fontSize: '0.8rem', color: '#6b7280' }}>
          Note: PM Dashboard 5-year path uses global factors (0.35→1.0). Per-linkage lag profiles are shown for reference.
        </p>
      </div>
    </div>
  );
}
